'use client';
import { useAuth } from '@/lib/auth-client';
import posthog from 'posthog-js';
import { useEffect, useRef } from 'react';

export function PostHogIdentity() {
  const { user, organizationId, loading } = useAuth();
  const wasIdentified = useRef(false);

  useEffect(() => {
    if (!posthog.__loaded || loading) return;
    if (user) {
      posthog.identify(user.id, { email: user.email });
      if (organizationId) {
        posthog.group('organization', organizationId);
      }
      wasIdentified.current = true;
    } else if (wasIdentified.current) {
      posthog.reset();
      wasIdentified.current = false;
    }
  }, [user, organizationId, loading]);

  return null;
}
